/**
 * The AI gateway wraps customer / document text in `<untrusted source="customer"> … </untrusted>`
 * so the model treats it as data, and the fake model prefixes its echo with `[fake:fake-chat]`.
 * Echoed or quoted, those markers leaked into the test console and the agent preview (QA). They
 * are plumbing, never something a person should read, whichever model produced the reply.
 */

// `<untrusted>`, `<untrusted source="customer">`, `</untrusted>` (any case, any attributes).
const WRAPPER_TAG = /<\/?untrusted\b[^>]*>/gi;
// A reply cut mid-tag (the fake model truncates its echo) leaves `<untrusted source="cus` behind.
const DANGLING_TAG = /<\/?untrusted\b[^>]*$/i;
// `[fake:fake-chat] ` at the very start of a reply.
const FAKE_PREFIX = /^\s*\[fake:[^\]\n]*\]\s*/i;

/** Strips the prompt wrapper tags and the fake-model prefix; `null` when nothing readable is left. */
export function cleanAgentReply(reply: string | null | undefined): string | null {
  if (reply === null || reply === undefined) return null;
  const cleaned = reply
    .replace(FAKE_PREFIX, "")
    .replace(WRAPPER_TAG, "")
    .replace(DANGLING_TAG, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
  return cleaned === "" ? null : cleaned;
}
